"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutableComponent = void 0;
var React = require("react");
var RoutableComponentsManager_1 = require("../RoutableComponentsManager");
var react_router_1 = require("react-router");
var utils_1 = require("../RoutableContainer/utils");
var RoutableComponent = /** @class */ (function (_super) {
    __extends(RoutableComponent, _super);
    function RoutableComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = React.createRef();
        _this.routableComponentsManager = RoutableComponentsManager_1.RoutableComponentsManager.getInstance();
        return _this;
    }
    RoutableComponent.prototype.componentWillUnmount = function () {
        this.deregisterComponent();
    };
    RoutableComponent.prototype.componentDidMount = function () {
        this.registerComponent();
    };
    // Let's update the registration if the props changed
    RoutableComponent.prototype.componentWillUpdate = function (props) {
        if (this.path !== this.getPath(props) || this.props.onDisplay !== props.onDisplay) {
            this.deregisterComponent();
            this.registerComponent(props);
        }
    };
    RoutableComponent.prototype.render = function () {
        return (React.createElement("div", { ref: this.ref, className: this.props.className }, this.props.children));
    };
    RoutableComponent.prototype.getPath = function (props) {
        return utils_1.concatPaths(props.match.url, props.path);
    };
    /** Register the current component with the passed props, or the current props if none passed. */
    RoutableComponent.prototype.registerComponent = function (props) {
        if (props === void 0) { props = this.props; }
        this.path = this.getPath(props);
        this.routableComponentsManager.registerComponent(this.path, this.ref, props.onDisplay, props.appendSlash);
    };
    /** Deregister this component using the current path */
    RoutableComponent.prototype.deregisterComponent = function () {
        if (this.path == null) {
            return;
        }
        this.routableComponentsManager.deregisterComponent(this.path);
    };
    return RoutableComponent;
}(React.Component));
exports.RoutableComponent = RoutableComponent;
exports.default = react_router_1.withRouter(RoutableComponent);
//# sourceMappingURL=RoutableComponent.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/RoutableComponent/RoutableComponent.js
// module id = 998
// module chunks = 8